import React from 'react'
import {Button, Grid, Card, Typography} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import colors from '../../../colors';
import List from '@material-ui/core/List';
import DeleteIcon from '@mui/icons-material/Delete';
import SingleCard from './SingleCard'
import { selectTopUpData, setSelectedCard} from '../../../../features/userInfo/topUpSlice';
import { sendGeneralRequest } from '../../../../features/generalRequest'
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AddNewCardButton from './AddNewCardButton'
import { texts } from '../../../general/texts';
import { selectGlobalDataState } from '../../../../features/global/globalDataSlice';
import { ReactComponent as NoContractIcon } from '../../../../icons/noContracts.svg';
import ListItemButton from '@mui/material/ListItemButton';

const CardList = () => {

  const topUpSliceState = useSelector(selectTopUpData)
  const globalDataSliceState = useSelector(selectGlobalDataState)
  const dispatch = useDispatch()
  const [anotherCardTopUp, setAnotherCardTopUp] = React.useState(false)

  const onDeleteButtonClick = (card) => 
  {
    dispatch(sendGeneralRequest({request: {_request:{token: globalDataSliceState.token, cardID: card.cardID}}, baseUrlKey:'services', endpoint:'RemoveCard'}))
  }

  const onCardClick = (selectedCard) => 
  {
    dispatch(setSelectedCard(selectedCard.cardID))
    setAnotherCardTopUp(false)
  }
  
  const onTopUpWithoutSavingCard = () => 
  {
    dispatch(setSelectedCard(''))
    setAnotherCardTopUp(true)
  }

  return (
    <Card sx={{width: '65%', padding: 4, borderRadius: '20px', boxShadow:'0 0 15px 5px #E5E7EA', '@media (max-width: 899px )' : {width:'80%'}}}>
      <Grid container item md={12} xs={12} justifyContent={'space-between'} marginBottom={5}>
        <Typography sx={{ color: colors.darkBlue, fontFamily:'GerberaBold', fontSize:'1.8rem'}}>{texts["title-my-cards"]}</Typography>
        <AddNewCardButton/>
      </Grid>
      <List >
        <Grid container item md={12} xs={12} spacing={3} >
            {topUpSliceState.cards.length > 0 ? topUpSliceState.cards.map((card, index) => {
                return <Grid container item md={12} xs={12} key={index} justifyContent={'center'}>
                            <Grid item md={10} xs={10}  >
                                <SingleCard cardInfo={card} onClick={() => onCardClick(card)}/>
                            </Grid>
                            <Grid container item md={2} xs={2} mt={-1}>
                                <Button disableRipple={true} sx={{background:colors.white, borderRadius:'100%', "&:hover":{background:colors.white}}} onClick={() => {onDeleteButtonClick(card)}} size='small' >
                                    <DeleteIcon color='warning' />
                                </Button>
                            </Grid>
                        </Grid>
            }):
            <Grid container item justifyContent={'center'} mt={'15%'}>
                <Grid item md={12} xs={12} pb={'10%'}>
                    <NoContractIcon/>
                </Grid>
                <Grid item md={7} xs={7} pb={'14%'}>
                    <Typography sx={{color:colors.darkBlue}} variant='h6'>{texts["title-no-cards"]}</Typography>
                </Grid>                                          
            </Grid>
            }
            {topUpSliceState.cards.length > 0 &&
              <Grid container item md={10.1} xs={12} justifyContent={'center'}>
                <ListItemButton selected={anotherCardTopUp} onClick={onTopUpWithoutSavingCard} sx={{width:'100%', height:'40px', borderRadius:'5px', backgroundColor:colors.white, color:colors.darkBlue, border: anotherCardTopUp ? '1px solid orange' : '1px solid #F0F0F0'}} >
                    <Grid container justifyContent={'flex-start'} >
                        <CreditCardIcon />
                        <Typography pl={1} sx={{fontFamily:'GerberaLight', color:colors.darkBlue}}>{texts["button-top-up-with-another-card"]}</Typography>
                    </Grid>
                </ListItemButton>
              </Grid>
            }
              
        </Grid>
    </List>
    </Card>
  )
}

export default CardList

// onClick={handleNewCardPaymentButtonClick}